"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tenantBootstrappedPayloadSchema = exports.financialYearClosedPayloadSchema = exports.sequenceExhaustedPayloadSchema = exports.licenseUpdatedPayloadSchema = exports.userPasswordResetPayloadSchema = exports.userLockedPayloadSchema = exports.userRoleAssignedPayloadSchema = exports.userCreatedPayloadSchema = exports.roleModulesAssignedPayloadSchema = exports.rolePermissionAssignedPayloadSchema = exports.roleCreatedPayloadSchema = exports.departmentCreatedPayloadSchema = exports.branchCreatedPayloadSchema = exports.hospitalCreatedPayloadSchema = exports.tenantCreatedPayloadSchema = exports.PlatformEventNames = void 0;
/**
 * Domain event names + payload schemas for the Platform Engine.
 * Registered into backend's core/eventbus event catalog at startup
 * (see modules/platform/*'s index.ts files) so publish() validates
 * against these shapes automatically. See /standards/NamingConvention.md
 * for the `domain.entity.action` format.
 */
const zod_1 = require("zod");
exports.PlatformEventNames = {
    TENANT_CREATED: 'tenant.created',
    TENANT_SUSPENDED: 'tenant.suspended',
    TENANT_ACTIVATED: 'tenant.activated',
    HOSPITAL_CREATED: 'hospital.created',
    BRANCH_CREATED: 'branch.created',
    DEPARTMENT_CREATED: 'department.created',
    ROLE_CREATED: 'role.created',
    ROLE_PERMISSION_ASSIGNED: 'role.permission-assigned',
    ROLE_MODULES_ASSIGNED: 'role.modules-assigned',
    USER_CREATED: 'user.created',
    USER_ROLE_ASSIGNED: 'user.role-assigned',
    /** A role taken AWAY. Grants without revocations is a picture that only grows. */
    USER_ROLE_REMOVED: 'user.role-removed',
    USER_LOCKED: 'user.locked',
    USER_PASSWORD_RESET: 'user.password-reset',
    LICENSE_UPDATED: 'license.updated',
    LICENSE_EXPIRED: 'license.expired',
    SEQUENCE_EXHAUSTED: 'sequence.exhausted',
    FINANCIAL_YEAR_CLOSED: 'financial-year.closed',
    TENANT_BOOTSTRAPPED: 'tenant.bootstrapped',
};
exports.tenantCreatedPayloadSchema = zod_1.z.object({
    tenantId: zod_1.z.string().uuid(),
    code: zod_1.z.string(),
});
exports.hospitalCreatedPayloadSchema = zod_1.z.object({
    hospitalId: zod_1.z.string().uuid(),
    tenantId: zod_1.z.string().uuid(),
});
exports.branchCreatedPayloadSchema = zod_1.z.object({
    branchId: zod_1.z.string().uuid(),
    hospitalId: zod_1.z.string().uuid(),
});
// Department Master enterprise rebuild — a department is now tenant-wide
// (branchId optional), so this event payload's branchId must be too.
exports.departmentCreatedPayloadSchema = zod_1.z.object({
    departmentId: zod_1.z.string().uuid(),
    branchId: zod_1.z.string().uuid().optional(),
});
exports.roleCreatedPayloadSchema = zod_1.z.object({
    roleId: zod_1.z.string().uuid(),
});
exports.rolePermissionAssignedPayloadSchema = zod_1.z.object({
    roleId: zod_1.z.string().uuid(),
});
exports.roleModulesAssignedPayloadSchema = zod_1.z.object({
    roleId: zod_1.z.string().uuid(),
});
exports.userCreatedPayloadSchema = zod_1.z.object({
    userId: zod_1.z.string().uuid(),
    tenantId: zod_1.z.string().uuid(),
    email: zod_1.z.string().email(),
});
exports.userRoleAssignedPayloadSchema = zod_1.z.object({
    userId: zod_1.z.string().uuid(),
    roleId: zod_1.z.string().uuid(),
});
exports.userLockedPayloadSchema = zod_1.z.object({
    userId: zod_1.z.string().uuid(),
});
exports.userPasswordResetPayloadSchema = zod_1.z.object({
    userId: zod_1.z.string().uuid(),
});
exports.licenseUpdatedPayloadSchema = zod_1.z.object({
    tenantId: zod_1.z.string().uuid(),
    licenseId: zod_1.z.string().uuid(),
});
exports.sequenceExhaustedPayloadSchema = zod_1.z.object({
    tenantId: zod_1.z.string().uuid(),
    entityType: zod_1.z.string(),
});
exports.financialYearClosedPayloadSchema = zod_1.z.object({
    tenantId: zod_1.z.string().uuid(),
    financialYearId: zod_1.z.string().uuid(),
});
exports.tenantBootstrappedPayloadSchema = zod_1.z.object({
    tenantId: zod_1.z.string().uuid(),
    hospitalId: zod_1.z.string().uuid(),
    branchId: zod_1.z.string().uuid(),
});
//# sourceMappingURL=platform.events.js.map